import React from 'react';
import { Item, registry, RenderProps } from '../Item';
import { ADD_NEW_ITEM } from '..';
import { useEditorStore, getEditorState } from '~/shell/Store';
import LightButton from '~/editor/buttons/LightButton';

interface Props {
  id?: string;
  value?: [];
  type?: string;
  title?: string;
}

export class AddNewItem extends Item<typeof ADD_NEW_ITEM, Props> {
  protected render({ type, title }: RenderProps<Props>) {
    const { addSubItem } = useEditorStore();

    const AddNewItem = () => {
      const currentSequence = useEditorStore.getState().sequence;

      let list = currentSequence.items.find(
        (item: { id: string; type: string }) => item.type === 'LIST'
      );

      if (type == 'CARD') {
        list = currentSequence.items
          .slice()
          .reverse()
          .find((item: { id: string; type: string }) => item.type === 'CARD');

        if (list) {
          const newItem = {
            ...list,
            id: `${Date.now()}`,
            position: list.position + 1,
            title: list.title ? 'Type Here' : null,
            body: list.body ? 'Type Here' : null
          };

          addSubItem({
            sequenceId: currentSequence.id,
            data: {
              type: 'CARD',
              title: list.title ? 'Type Here' : null,
              body: list.body ? 'Type Here' : null,
              position: newItem.position
            },
            newItem: newItem,
            onCreated: async (realId: string | number) => {
              const state = getEditorState();
              const api = (state as any).apiService;
              try {
                if (api) {
                  // only persist pictures if there are valid ids
                  const validPicturesIds = list.pictures
                    .map((p: any) => p.id)
                    .filter(Boolean);
                  if (validPicturesIds.length) {
                    await api.updateSubItem(
                      realId,
                      'picture_ids',
                      validPicturesIds
                    );
                  }

                  const validAudiosIds = list.audios
                    .map((p: any) => p.id)
                    .filter(Boolean);
                  if (validAudiosIds.length) {
                    await api.updateSubItem(
                      realId,
                      'audio_ids',
                      validAudiosIds
                    );
                  }

                  const validVideosIds = list.videos
                    .map((p: any) => p.id)
                    .filter(Boolean);
                  if (validVideosIds.length) {
                    await api.updateSubItem(
                      realId,
                      'video_ids',
                      validVideosIds
                    );
                  }
                }
              } catch (e) {
                console.error('Duplicate card persistence failed', e);
              }
            }
          });
        }
        return;
      }

      if (list && list.items && list.items.length > 0) {
        const newItem = {
          ...list.items[list.items.length - 1],
          id: `${Date.now()}`,
          type: 'Text',
          position: list.items.length + 1,
          title: null,
          body: 'Type Here'
        };

        addSubItem({
          sequenceId: currentSequence.id,
          data: {
            type: 'Text',
            title: null,
            body: 'Type Here',
            position: newItem.position,
            parent_id: list.id
          },
          newItem: newItem
        });
      }
    };

    return (
      <LightButton
        style={{
          minWidth: title ? '200px' : '140px',
          maxWidth: '140px',
          marginTop: '20px',
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'block'
        }}
        onClick={AddNewItem}
      >
        {title || 'Add Item'}
      </LightButton>
    );
  }
}

registry[ADD_NEW_ITEM] = AddNewItem;
